import { useState } from 'react';
import { useUpdateEffect } from './useUpdateEffect';
import automobyApi, { baseURL } from '../Api';
import axios from 'axios';
 
export const useNewUser = (defaultPageSize) => {
  const [items, setItems] = useState([]);
  const [total, setTotal] = useState(0); 
  const [filter, setFilter] = useState({
    all: true,
    limit: defaultPageSize,
    order_by: "id",
    page: 1,
    firstname: "",
    lastname: "",
    personal: "",
    email: "",
    mobile: ""
  });

  useUpdateEffect(() => {
    if (defaultPageSize > 0){
      fetchList();
    }
     
  }, [filter]);
 
  const fetchList = async () => {
    try {
      const response = await automobyApi.post("/new/user/list", filter)
      setItems(response.data.new_users);
      setTotal(response.data.total);
      return response.data.new_users
    } catch (error) { 
      console.error("error:" + error);
    }
  }

  const fetch = async () => {
    try {
      const requestData = {
        all: true,
        limit: 100,
        order_by: "id",
        offset: 1
      };

      const response = await automobyApi.post("/new/user/all", requestData)
      setItems(response.data.new_users);
      setTotal(response.data.total);
      return response.data.new_users
    } catch (error) {

      console.error("error:" + error);
    }
  }

  
  const add = (newData) => {
    return new Promise(async (resolve, reject) => {
      try {
        
        const response = await axios.post( baseURL + '/user/signup', newData);
     
        resolve(response);
      } catch (error) {
        reject(error);
      }
    });
  } 
 

  const search = async (new_user, count) => {
    try {
      const requestData = {
        new_user: new_user,
        count: count,
      };

      const response = await automobyApi.post("/new/user/search", requestData)
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }

  const update = async (newData) => {
    try {
      const response = await automobyApi.post(`/new/user/update`, newData);
      fetchList();
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }

  const remove = (id) => {
    return new Promise(async (resolve, reject) => {
      try {
        const requestData = {
          new_user_id: id
        };
        const response = await automobyApi.post(`/new/user/delete`, requestData);
        fetchList();
        resolve(response);
      } catch (error) {
        reject(error);
      }
    });
  } 

  const updateLocal = async (new_user) => {
    setItems(items.map(item =>
      item.id === new_user.id ? new_user : item
    ));
  }
 

  const newUserService = {
    items: items,
    total: total,
    filter: filter, 
    setFilter: setFilter,
    fetch: fetch,
    fetchList: fetchList,
    add: add,
    search: search,
    update: update,
    remove: remove, 
  };

  return { newUserService };
}